import { EntityData, initialEntityData } from '@new/common/utils/entity-data';
import { Task } from '../../../lib/types';

export interface TaskStateModel {
  item: EntityData<Task>;
}

export const taskStateDefaults: TaskStateModel = {
  item: initialEntityData()
};
